/*
    比价单品页
    @author: wanghui@gwdang.com
 */
import '../../css/product.less';

import PriceHistory from '../../Service/PriceHistory'
import JdRankList from "../../components/JdRankList";

const tpl = $('#tpl_now').text();
let chart;
let zmpubTxt = $('.zmpubTxt');

if (tpl === 'trend') {
    zmpubTxt = $('.zmpubBox');
}
let zmpubTxt_top = zmpubTxt.length && zmpubTxt.offset().top || 0;

function initBigTrend() {
    try{
        let dp_id = $('#big_price_chart').attr('dp_id');
        showBigChart(dp_id, 'big_price_chart');
        $('#tab_trend').attr('inited', 1);
    }catch(e){}
}

// 大的走势图，现在只有单品页的价格历史column在用
async function showBigChart(dp_id, chart_id){
    let r = await PriceHistory.get(dp_id, 180);
    if (r.series.length > 0) {
        let obj = {
            credits:{ enabled: false },
            colors: [ '#2f7ed8' ],
            chart: {
                renderTo: chart_id,
                type: 'line',
                spacingTop: 10,
                spacingBottom: 5,
                spacingLeft: 0,
                spacingRight: 20
            },
            title: {
                text: '\u6700\u8fd1' + 180 + '\u5929\u4ef7\u683c\u5386\u53f2',
                style:{ color:'#2f7ed8' }
            },
            xAxis: {
                type: 'datetime',
                dateTimeLabelFormats:{
                    day: '%m-%d',
                    week: '%m-%d',
                    month: '%m-%d'
                },
                minorGridLineColor: '#dfdfdf',
                minorTickInterval: 'auto'
            },
            yAxis: {
                title: {
                    text: '\u4ef7\u683c(\u5143)',
                    margin:20
                },
                minorGridLineColor: '#dfdfdf',
                minorTickInterval: 'auto'
            },
            tooltip: {
                xDateFormat: '%Y-%m-%d',
                shared: true,
                valuePrefix: '&yen;',
                useHTML: true,
            },
            legend: {
                itemStyle:{
                    paddingTop: 5,
                    paddingLeft:10,
                    paddingRight:10
                }
            },
            plotOptions: {
                series: {
                    pointInterval: 86400000,
                    marker: { radius: 2 },
                    shadow: false
                }
            },
            series:[]
        };

        const len = r.series.length;
        for(let i = 0; i < len; i++){
            let store = r.series[i];
            obj.series[i] = {
                visible:false,
                name: '到手价/页面价',
                data:[]
            };
            if(Number(store.period) === 180){
                obj.series[i].visible = true;
            }
            store.data.forEach(function (point, index) {
                point.x *= 1e3;
                point.y /= 1e2;
            });

            obj.series[i].data = store.data
        }
        chart = new Highcharts.Chart(obj);
        $('#'+chart_id).show();
    }
}

let $tabTrend = $('#tab_trend');
if ($tabTrend.length && $tabTrend.hasClass('selected') && Number($tabTrend.attr('inited')) === 0) {
    initBigTrend();
}

// tab切换
$('.zmpubTxt li[id^=tab_]').click(function() {

    $("html,body").animate({scrollTop:zmpubTxt_top},100);
    $(this).addClass('selected').siblings().removeClass('selected');
    let cur_index = Number($(this).attr('index')),
        objDiv = $(this).parents('.zmpubTab').find('.zmpubBot .zmpubBox');

    $(objDiv).each(function(i){
        if(i === cur_index) {
            $(this).show();
        }  else {
            $(this).hide();
        }

        $(window).resize();
    });

    try{
        let dataObj = {};
        let url = window.location.href;
        let to_tab = $(this).attr('to');
        url = url.replace(/(dp[^\/]+)\/((?:where_buy|desc|reviews|trend|ingredients))((\/.*?)*.*?)$/ig, '$1/'+to_tab+'$3');
        url = url.replace(/(dp[^\/]+)\/?$/ig, '$1/'+to_tab);
        history.pushState(dataObj, document.title, url);
        if('pushState' in history) {
            history.pushState(dataObj, document.title, url);
        } else {
            //修复IE下评论列表无内容
            if(to_tab === "reviews"){ window.location.href = url; }
        }

        if (to_tab === 'ingredients') {
            _hmt && _hmt.push(['_trackEvent', 'www', '点击', '化妆品成分']);
        }

        if ($(this).attr('id') === 'tab_trend' && Number($(this).attr('inited')) === 0) {
            initBigTrend();
        }
    }catch(e){}
});

// tab栏浮动
$(window).scroll(function () {
    let scotop = document.body.scrollTop ? document.body.scrollTop : document.documentElement.scrollTop;

    if (tpl === 'trend') {
        let $tabWrap = $('#trend-where-buy').find('#tab_wrap');
        if ($tabWrap.length && scotop > $tabWrap.offset().top) {
            $tabWrap.find('.compare-site-list').addClass('fixed');
        } else {
            $tabWrap.find('.compare-site-list').removeClass('fixed')
        }
    } else {
        if (scotop > zmpubTxt_top) {
            zmpubTxt.addClass('zmpubTxt_fixed');
            $('.zmpubTab .compare-site-list').addClass('anchor_fixed');
        } else {
            zmpubTxt.removeClass('zmpubTxt_fixed');
            $('.zmpubTab .compare-site-list').removeClass('anchor_fixed');
        }
    }
});

// 比价列表/弹出框价格历史
require('./product_where_buy_module');

// 商品加入收藏
require('./addCollection');

if (tpl !== 'product_middlepage') {
    if (is_price_protect == 1) {
        // 价格保护
        require('./priceProtect');
    }
}

if (window.rankList && window.rankList.rank_p) {
    console.log('start')
    new Vue({
        el: '#rankList',
        render: h => h(JdRankList, {
            props: {
                data: window.rankList.rank_p,
                additionalClass: 'gwd-w266',
            }
        })
    })
}
